// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2e-1";
export var rateTableServiceLevelDropdown = "_2e-3";
export var rateTableTypeDropdown = "_2e-0";
export var rateTableValueModeDropdown = "_2e-2";